import { createAction } from '@ngrx/store';

export enum App {
  INITIALIZE = '[App] Initialize',
  INITIALIZE_SUCCESS = '[App] Initialized',
  INITIALIZE_FAILED = '[App] Cannot initialize',
  LOGOUT = '[App] Logout',
  LOGOUT_SUCCESS = '[App] Logged out',
  LOGOUT_FAILED = '[App] Cannot logout',
  SET_USER = '[App] Set user',
  SET_USER_SUCCESS = '[App] User set',
  SET_USER_FAILED = '[App] Cannot set user',
  SET_COMPANY = '[App] Set company',
}

export enum ResetActions {
  RESET = '[Reset] Reset state',
}

export const initApp = createAction(App.INITIALIZE);
export const resetState = createAction(ResetActions.RESET);
